import { Notice } from 'telia-front-react';
import * as React from 'react';

interface IBoxNoticeProps {
  children: React.ReactChild | React.ReactChild[];
  type?: 'error' | 'success' | 'employee';
}

export default class BoxNotice extends React.Component<IBoxNoticeProps> {
  public render(): JSX.Element {
    return (
      <Notice type={this.props.type} className="text-bold" align="center">
        {this.props.children}
      </Notice>
    );
  }
}
